import React, { PureComponent, createRef } from "react";
import classnames from "classnames";
import { Trigger } from "@ss/mtd-react/lib/utils/react";
import throttle from "lodash/throttle";
import { Button, Icon, Input, Dropdown, Menu } from "@ss/mtd-react";
import "./style.scss";
import { generateId } from "../../utils";
import { GlobalSearchType } from "@/utils/constant/home";
import GlobalSearch from "@/components/global-search-component";
import qs from "qs";
import { Resource_Type_Identifier } from "@/utils/constant/teamManagement";
import { getUserInfo } from "@/utils/index";
import { i18nClient } from "@sailor/i18n-web";
import { I18N_KEYS, getNameSpaceKey } from "@/utils/constant/i18nStatic";
import RotatingTextWithBackground from "./RotatingTextWithBackground";
import LottieRotator from "@/components/LottieRotator";
import homeBackground from "@/assets/images/home_background.png";
import BrandSearch from "@/pages/BrandAggregation/BrandSearch";
import momentLottie from "@/assets/lottie/moments.json";
import consistencyLottie from "@/assets/lottie/consistency.json";
import resonanceLottie from "@/assets/lottie/resonance.json";
import lifeLottie from "@/assets/lottie/life.json";
// import firstBackground from "@/assets/images/background_first.png";
// import secondBackground from "@/assets/images/background_second.png";
// import thirdBackground from "@/assets/images/background_third.png";
// import fourthBackground from "@/assets/images/background_fourth.png";

const MenuItem = Menu.Item;
const lottieAnimationInfo = {
    Moments: {
        position: "relative",
        left: "-65px",
        top: "20px",
        width: 420
    },
    Consistency: {
        position: "relative",
        left: "-80px",
        top: "13px",
        width: 475
    },
    Resonance: {
        position: "relative",
        left: "-177px",
        top: "9px",
        width: 680 // 544
    },
    Life: {
        // marginLeft: '40px',
        position: "relative",
        left: "25px",
        top: "-8px",
        width: 275 // 328
    }
};

const lottieTextInfo = {
    Moments: {
        transform: "translateX(120px)"
    },
    Consistency: {
        transform: "translateX(110px)"
    },
    Resonance: {
        transform: "translateX(95px)"
    },
    Life: {
        transform: "translateX(205px)"
    }
};

export default class Home extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            scrollClassName: "",
            searchSourceTypeList: GlobalSearchType,
            searchSourceType: GlobalSearchType[0],
            isShowSearch: false,
            materialType: Resource_Type_Identifier.ALL,
            lottieAnimations: [
                momentLottie,
                consistencyLottie,
                resonanceLottie,
                lifeLottie
            ],
            animationNames: ["Moments", "Consistency", "Resonance", "Life"],
            currentAnimationIndex: 0,
            currentTransitionIndex: 0,
            isContainerWidthChanging: false,
            currentBackgroundIndex: 0,
            prevBackgroundIndex: 0,
            isSliding: false,
            slideDirection: "right"
        };
        this.animationTimer = null;
        this.keetaTextRef = createRef();
        this.containerRef = createRef();
    }

    handleAnimationChange = (index, width) => {
        // if (index === this.state.currentBackgroundIndex) return;
        // const currentAnimationIndex = this.state.currentAnimationIndex;
        // const { slideNext } = this.props?.changeBgAniState || (() => {});
        // if (index !== currentAnimationIndex) {
        //     slideNext(index);
        // }
        this.setState({
            // currentBackgroundIndex: index,
            currentAnimationIndex: index
        });
        // const slideDirection = index > this.state.currentBackgroundIndex ? 'right' : 'left';
        // this.setState({
        //     prevBackgroundIndex: this.state.currentBackgroundIndex,
        //     currentBackgroundIndex: index,
        //     isSliding: true,
        //     slideDirection
        // });
        // setTimeout(() => {
        //     this.setState({ isSliding: false });
        //     // 动画结束后同步外部背景
        //     this.props.changeAppConatinerStyle({
        //         backgroundImage: `url(${backgroundImages[index]})`,
        //         backgroundSize: "100% 100%",
        //         backgroundRepeat: "no-repeat"
        //     });
        // }, 1000);
    };

    handleTransitionStart = (index) => {
        const currentAnimationIndex = this.state.currentAnimationIndex;
        const { slideNext } = this.props?.changeBgAniState || (() => {});
        if (index !== currentAnimationIndex) {
            slideNext(index);
        }
        this.setState({
            currentTransitionIndex: index
        });
    };

    async componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        // const tracker = window.LXAnalytics("getTracker");
        // const pageCase = tracker(
        //     "pageView",
        //     {},
        //     environment,
        //     "c_techportal_20l0xjy8"
        // );
        // pageCase("moduleView", "b_techportal_8lno6a5c_mv", {});
        // 设置初始背景图
        // this.props.changeAppConatinerStyle({
        //     backgroundImage: `url(${backgroundImages[1]})`,
        //     backgroundSize: "100% 100%",
        //     backgroundRepeat: "no-repeat",
        //     backgroundPosition: "center"
        // });
        const { changeBgAniShow } = this.props?.changeBgAniState || (() => {});
        changeBgAniShow(true);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        // this.props.changeAppConatinerStyle({
        //     backgroundImage: "none",
        //     backgroundSize: "100% 100%",
        //     backgroundRepeat: "no-repeat"
        // });
        const { changeBgAniShow } = this.props?.changeBgAniState || (() => {});
        changeBgAniShow(false);
        if (this.animationTimer) {
            clearInterval(this.animationTimer);
        }
    }

    handleScroll = throttle(() => {
        this.setState({
            scrollClassName:
                document.documentElement.scrollTop > 5
                    ? "home-header-scrolling-class"
                    : ""
        });
    }, 100);

    handleSearchType = resourceType => {
        this.setState({
            searchSourceType: resourceType
        });
    };

    renderSourceType = () => {
        const { searchSourceTypeList, searchSourceType } = this.state;
        return (
            <Menu
                inlineIndent={8}
                defaultSelectedKeys={[searchSourceType.value]}
            >
                {searchSourceTypeList.map(item => (
                    <MenuItem
                        key={item.value}
                        onClick={() => this.handleSearchType(item)}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        );
    };

    jumpToSearch = keyword => {
        this.props.history.push(
            `/search-result?keyword=${encodeURIComponent(keyword)}`
        );
    };

    handleSourceTypeChange = data => {
        this.setState({ materialType: data.value });
    };

    render() {
        const {
            materialType,
            lottieAnimations,
            animationNames,
            currentAnimationIndex,
            isContainerWidthChanging,
            currentTransitionIndex
        } = this.state;
        return (
            <div className="home-header-wrap">
                {/* <div className="bg-slider">
                    <div
                        className={`bg-img ${isSliding ? 'slide-out-' + slideDirection : ''}`}
                        style={{ backgroundImage: `url(${backgroundImages[prevBackgroundIndex]})` }}
                    />
                    {isSliding && (
                        <div
                            className={`bg-img slide-in-${slideDirection}`}
                            style={{ backgroundImage: `url(${backgroundImages[currentBackgroundIndex]})` }}
                        />
                    )}
                </div> */}
                <div className="home-header-search-wrap">
                    <div style={{ height: 72 }}></div>
                    <div className="textRotateLines">
                        <div className="firstLineContainer">
                            Designs Shaping
                        </div>
                        <div className="secondLineContainer">
                            <div
                                ref={this.keetaTextRef}
                                style={
                                    lottieTextInfo[
                                        animationNames[currentTransitionIndex]
                                    ]
                                }
                                className={`keeta-text ${
                                    isContainerWidthChanging ? "animating" : ""
                                }`}
                            >
                                Keeta
                            </div>
                            <div className="lottieAnimationContainerWrapper">
                                <div
                                    ref={this.containerRef}
                                    className="lottieAnimationContainer"
                                    style={
                                        lottieAnimationInfo[
                                            animationNames[
                                                currentAnimationIndex
                                            ]
                                        ]
                                    }
                                >
                                    <LottieRotator
                                        animations={lottieAnimations}
                                        animationNames={animationNames}
                                        rotationInterval={4000}
                                        style={{
                                            height: "300px"
                                        }}
                                        onAnimationChange={
                                            this.handleAnimationChange
                                        }
                                        onTransitionStart={
                                            this.handleTransitionStart
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="home-search-wrap">
                        <BrandSearch
                            className="search-result"
                            onSearch={this.jumpToSearch}
                            historyKey="homeSearchList"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
